import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    pageTitle: "Home", // current page title state management
    noOfNotifications: 2, // no of unread notifications
    newNotificationMessage: "", // message of notification to be shown
    newNotificationStatus: 1, // to check the notification type -  success/ error/ info
    pageBgColor:""
  },
  reducers: {
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload.title;
      state.pageBgColor = action.payload.bgColor || 'bg-base-200';
    },
    setPageBg: (state, action) => {
      state.pageBgColor = action.payload.bgColor || 'bg-base-200';
    },

    removeNotificationMessage: (state, action) => {
      state.newNotificationMessage = "";
    },

    showNotification: (state, action) => {
      // console.log(action)
      state.newNotificationMessage = action.payload.message;
      state.newNotificationStatus = action.payload.status;
    },
  },
});

export const { setPageTitle, removeNotificationMessage, showNotification, setPageBg } =
  headerSlice.actions;

export default headerSlice.reducer;
